<template>
	<el-dialog
		:title="projectStatus === '1' ? '项目结项' : '项目中止'"
		:visible.sync="dialogVisible"
		width="30%"
		top="10vh"
		:close-on-click-modal="false"
		:before-close="handleClose"
		custom-class="depreciation-dialog">
		<el-form ref="formRef" :model="form" :rules="rules" size="small">
			<el-row :gutter="16">
				<template v-if="projectStatus === '1'">
					<el-col :span="24">
						<el-form-item label="结项时间" prop="endDate">
							<el-date-picker v-model="form.endDate" type="date" placeholder="请选择结项时间" style="width: 100%" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="结项原因" prop="remake">
							<el-input type="textarea" :rows="3" v-model="form.remake" placeholder="请输入结项原因" />
						</el-form-item>
					</el-col>
				</template>
				<template v-if="projectStatus === '2'">
					<el-col :span="24">
						<el-form-item label="中止时间" prop="endDate">
							<el-date-picker v-model="form.endDate1" type="date" placeholder="请选择中止原因" style="width: 100%" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="中止原因" prop="remake">
							<el-input type="textarea" :rows="3" v-model="form.remake1" placeholder="请输入中止原因" />
						</el-form-item>
					</el-col>
				</template>
			</el-row>
		</el-form>

		<!-- footer -->
		<template #footer>
			<el-button @click="handleClose">取消</el-button>
			<el-button type="primary" @click="handleSubmit">确定</el-button>
		</template>
	</el-dialog>
</template>

<script>
	export default {
		name: 'ProjectStatusDialog',
		props: {
			dialogVisible: Boolean,
			projectStatus: {
				type: String,
				default: '1',
			},
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.$refs.form && this.$refs.form.resetFields();
					});
				}
			},
		},
		data() {
			return {
				form: {
					endDate: '',
					remark: '',
					endDate1: '',
					remark1: '',
				},
				rules: {
					remark: [{ required: true, message: '请输入结项原因', trigger: 'blur' }],
					endDate: [{ required: true, message: '请选择结项时间', trigger: 'change' }],
					remark1: [{ required: true, message: '请选择中止原因', trigger: 'blur' }],
					endDate1: [{ required: true, message: '请输入中止原因', trigger: 'change' }],
				},
			};
		},
		methods: {
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			handleSubmit() {
				this.$refs.form.validate(valid => {
					if (!valid) return;
					this.$emit('update:dialogVisible', false);
				});
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.depreciation-dialog) {
		.no-spinner .el-input__inner::-webkit-outer-spin-button,
		.no-spinner .el-input__inner::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}

		.no-spinner .el-input__inner[type='number'] {
			-moz-appearance: textfield; /* Firefox */
		}

		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #bbbbbb;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}
	}

	.cards {
		margin-bottom: 20px;
	}
</style>
